export default __webpack_public_path__ + "static/media/support-img.dd644428.jpg";